import { provideDataClass } from "scrivito"

import { apolloClient } from "app/apolloRestLink"

import { DeleteTeamDocument } from "entities/teams/graphql/mutations.generated"
import {
  TeamDocument,
  TeamQuery,
  TeamQueryVariables,
  TeamsQuery
} from "entities/teams/graphql/queries.generated"

export const TeamDataClass = provideDataClass("Team", {
  connection: {
    index: async () => {
      const teams = await apolloClient
        .query<TeamsQuery, TeamQueryVariables>({
          query: TeamDocument
        })
        .then(result => result.data.teams)
        .catch(() => [])

      return {
        results: teams || []
      }
    },

    get: async id => {
      return apolloClient
        .query<TeamQuery, TeamQueryVariables>({
          query: TeamDocument,
          variables: { id }
        })
        .then(result => result.data.team)
        .catch(() => null)
    },

    delete: async (id: string) => {
      return apolloClient
        .mutate({
          mutation: DeleteTeamDocument,
          variables: { id }
        })
        .then(result => result.data)
    }
  }
})
